import * as next from '../../../types/next'
import type { NumberInputControlOptions } from '../../../utils'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.NumberInputBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.NUMBER_INPUT_CONTROL) {
    throw new Error('Expected a valid Number Input control')
  }

  const castedOptions = uischema.options as NumberInputControlOptions<string>

  return {
    type: next.BLOCK_TYPE.NUMBER_INPUT,
    settings: {
      ...upCommonSettings(uischema),
      adornmentIcon: castedOptions.input_icon,
      unit:
        castedOptions.fields.numberInput.unit &&
        castedOptions.fields.numberInput.unit.label
          ? {
              show: Boolean(castedOptions.fields.numberInput.unit.show),
              label: castedOptions.fields.numberInput.unit.label
            }
          : undefined,
      format: castedOptions.fields.numberInput.format,
      range: castedOptions.fields.numberInput.range
        ? {
            min: castedOptions.fields.numberInput.range.min ?? 0,
            max: castedOptions.fields.numberInput.range.max ?? 'Infinity'
          }
        : undefined,
      suggestions: castedOptions.suggestions,
      suggestionIcon: castedOptions.suggestions
        ? castedOptions.iconInputName
        : undefined
    }
  }
}
